// extracted by mini-css-extract-plugin
module.exports = {"root":"IconsSection_root__2ccVg","root--oneLine":"IconsSection_root--oneLine__tSB63","list":"IconsSection_list__PLddD","rotation":"IconsSection_rotation__zJAZz"};